import { render, staticRenderFns } from "./ResultModal.vue?vue&type=template&id=2abb7876&scoped=true"
import script from "./ResultModal.vue?vue&type=script&lang=js"
export * from "./ResultModal.vue?vue&type=script&lang=js"
import style0 from "./ResultModal.vue?vue&type=style&index=0&id=2abb7876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb7876",
  null
  
)

export default component.exports